var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Column, CreateDateColumn, Entity, Index, PrimaryGeneratedColumn, Unique, UpdateDateColumn } from 'typeorm';
let AssetsHistory = class AssetsHistory {
    id;
    msafeAddress;
    txDigest;
    coinType;
    amount;
    isReceive; // distinguish between receive and spend
    executedAt;
    updatedAt;
    createdAt;
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], AssetsHistory.prototype, "id", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], AssetsHistory.prototype, "msafeAddress", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], AssetsHistory.prototype, "txDigest", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], AssetsHistory.prototype, "coinType", void 0);
__decorate([
    Column('bigint'),
    __metadata("design:type", String)
], AssetsHistory.prototype, "amount", void 0);
__decorate([
    Column(),
    __metadata("design:type", Boolean)
], AssetsHistory.prototype, "isReceive", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", Number)
], AssetsHistory.prototype, "executedAt", void 0);
__decorate([
    UpdateDateColumn(),
    __metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], AssetsHistory.prototype, "updatedAt", void 0);
__decorate([
    CreateDateColumn(),
    __metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], AssetsHistory.prototype, "createdAt", void 0);
AssetsHistory = __decorate([
    Entity({ name: 'user_assets_history' }),
    Unique(['msafeAddress', 'txDigest', 'coinType']),
    Index(['msafeAddress', 'coinType', 'isReceive', 'executedAt'])
], AssetsHistory);
export { AssetsHistory };
//# sourceMappingURL=module.js.map